import { ReactElement } from "react";
import { Box } from "@twilio-paste/core/box";
import { SkeletonLoader } from "@twilio-paste/core/skeleton-loader";

const PromptSuggestionsLoader = (): ReactElement => (
  <Box
    as="div"
    display="flex"
    flexDirection="column"
    rowGap="space40"
    alignItems="center"
    marginY="space50"
  >
    <SkeletonLoader borderRadius="borderRadiusPill" height="28px" width="60%" />
    <SkeletonLoader borderRadius="borderRadiusPill" height="28px" width="40%" />
    <SkeletonLoader borderRadius="borderRadiusPill" height="28px" width="45%" />

    <Box
      as="div"
      display="flex"
      flex={1}
      alignItems="center"
      justifyContent="center"
      width="100%"
      columnGap="space40"
    >
      <SkeletonLoader
        borderRadius="borderRadiusPill"
        height="28px"
        width="35%"
      />
      <SkeletonLoader
        borderRadius="borderRadiusPill"
        height="28px"
        width="35%"
      />
    </Box>

    <SkeletonLoader borderRadius="borderRadiusPill" height="28px" width="50%" />
  </Box>
);

export default PromptSuggestionsLoader;
